<template>
    <div :class="['wrapper', 'step-' + currentStep]">
        <div class="row">
            <div class="col-12">
                <h1>Odhad ceny nemovitosti</h1>
                <div class="wizard-position">
                    <span v-for="index in steps" :key="index"
                          :class="[
                            index <= currentStep ? 'active' : '',
                            index > maxVisitedStep ? 'disabled' : '',
                          ]" v-on:click="setStep(index)"
                    ></span>
                </div>
                <h2>{{ titles[currentStep - 1] }}</h2>
                <small class="small-header">{{ smallTitles[currentStep - 1] }}</small>
            </div>
        </div>
        <div class="row">
            <div class="wrapper" v-show="currentStep === 1">
                <valuo-form-step-calculation :assets-url="assetsUrl"></valuo-form-step-calculation>
            </div>
            <div class="wrapper" v-show="currentStep === 2">
                <valuo-form-step-type :assets-url="assetsUrl"></valuo-form-step-type>
            </div>
            <div class="wrapper" v-show="currentStep === 3">
                <valuo-form-step-parameters :assets-url="assetsUrl"></valuo-form-step-parameters>
            </div>
            <div class="wrapper" v-show="currentStep === 4">
                <valuo-form-step-floor :assets-url="assetsUrl"></valuo-form-step-floor>
            </div>
            <div class="wrapper" v-show="currentStep === 5">
                <valuo-form-step-condition :assets-url="assetsUrl"></valuo-form-step-condition>
            </div>
            <div class="wrapper" v-show="currentStep === 6">
                <valuo-form-step-more :assets-url="assetsUrl"></valuo-form-step-more>
            </div>
            <div class="wrapper" v-show="currentStep === 7">
                <valuo-form-step-address :assets-url="assetsUrl"></valuo-form-step-address>
            </div>
            <div class="wrapper" v-show="currentStep === 8">
                <valuo-form-step-motivation :assets-url="assetsUrl"></valuo-form-step-motivation>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <a href="#" class="btn btn-red transparent" v-on:click="stepBack">Zpět</a>
                <input v-if="currentStep === 8" class="btn btn-red" type="submit" value="Pokračovat" v-on:click.prevent="checkBeforeSubmit()">
                <a href="#" v-else class="btn btn-red" v-on:click="stepNext">Pokračovat</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Valuo-Form",

        props: ['backlink', 'assetsUrl'],

        data: function() {
            return {
                currentStep: 1,
                maxVisitedStep: 1,
                steps: 8,
                titles: [
                    'Prodej/Pronájem',
                    'Typ nemovitosti',
                    'Parametry',
                    'Podlaží',
                    'Stav',
                    'Další informace',
                    'Adresa',
                    'Proč si odhad počítáte?'
                ],
                smallTitles: [
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    'Čím přesnější adresu zadáte, tím přesnější bude odhad',
                    'Vaše odpověď nemá vliv na výsledek',
                ],
                type: 'flat'
            }
        },

        methods: {
            stepBack: function () {
                if (this.currentStep !== 1) {
                    this.currentStep--;

                    if (this.currentStep === 4 && (this.type === 'house' || this.type === 'cottage')) {
                        this.currentStep--;
                    }
                } else {
                    window.location.href = this.backlink;
                }
            },

            stepNext: function () {
                if (!this.checkRequired(this.currentStep)) {
                    return false;
                }

                if (this.currentStep !== this.steps) {
                    this.currentStep++;
                }

                if (this.currentStep === 4 && (this.type === 'house' || this.type === 'cottage')) {
                    this.currentStep++;
                }

                if (this.maxVisitedStep < this.currentStep) {
                    this.maxVisitedStep = this.currentStep;
                }
            },

            setStep: function (step) {
                if (step > this.currentStep && step <= this.maxVisitedStep && !this.checkRequired(this.currentStep)) {
                    return false;
                }

                if (step === 4 && (this.type === 'house' || this.type === 'cottage')) {
                    return false;
                }

                if (step <= this.maxVisitedStep) {
                    this.currentStep = step;
                }
            },

            setType: function (type) {
                this.type = type;
            },

            getType: function () {
                return this.type;
            },

            checkRequired: function (step) {
                if (!this.$children[step - 1].required) {
                    alert('Vyplňte prosím všechny povinné parametry.');
                    return false;
                }

                return true;
            },

            checkBeforeSubmit: function () {
                if (this.checkRequired(8)) {
                    $('#calculation-form').submit();
                }
            }
        }
    }
</script>

<style scoped>
    .wizard-position span {
        cursor: pointer;
    }

    .wizard-position span.disabled {
        cursor: not-allowed;
    }

    .small-header {
        color: #9d9d9d;
    }
</style>